import LaunchpadLiveSessionCard from "./LaunchpadLiveSessionCard"
import { makeStyles } from "tss-react/mui-compat"
import InfiniteHorizontalScroller from "components/InfiniteHorizontalScroller"
import useLaunchpadContext from "hooks/useLaunchpadContext"
import useCurrent from "lib/use-current"
import ConventionSession from "models/convention-api/v1/ConventionSession"
import moment from "moment-timezone"
import { useState } from "react"

const useStyles = makeStyles()({
  root: {},
  text: {
    marginTop: "20px",
    color: "#000000",
    fontFamily: "Lato",
    fontStyle: "normal",
    fontWeight: "normal",
    fontSize: "16px",
    lineHeight: "22px",
  },
})

interface ILaunchpadLiveSessions {}

const LaunchpadLiveSessions = (_props: ILaunchpadLiveSessions) => {
  // We need to make sure to store the page load time to prevent
  // Re-renders, and must be in a 5 min increment to help reduce cache misses
  // Made you read!
  const [pageLoadTime, _setPageLoadTime] = useState(() => {
    const precision = 5 * 60 * 1000
    return moment(Math.round(+new Date() / precision) * precision)
  })

  const current = useCurrent()

  const { convention } = useLaunchpadContext()

  const { data: liveSessions } = ConventionSession.useAll({
    filter: {
      convention_id: convention.id,
      // @ts-ignore
      exclude_institution_id: current.config.institution_id,
      start_at_lteq: pageLoadTime.clone().add(15, "minutes").toISOString(),
      end_at_gt: pageLoadTime.toISOString(),
    },
    includes: ["convention_exhibitor"],
  })

  const { classes } = useStyles()

  if (!liveSessions || liveSessions.length === 0) {
    return null
  }

  return (
    <div className={classes.root}>
      <InfiniteHorizontalScroller
        hasMore={false}
        loadMore={() => {}}
        loading={false}
        title="Happening Now"
        emptyStateMessage="No sessions found"
        scrollSpeed={300}>
        {liveSessions.map((session: ConventionSession) => (
          <LaunchpadLiveSessionCard key={session.id} session={session} />
        ))}
      </InfiniteHorizontalScroller>
    </div>
  )
}

export default LaunchpadLiveSessions
